
<!-- Shared base template -->
<app-base-confirm-password-form  [templateSettings]="templateSettings"></app-base-confirm-password-form>



// WEBPACK FOOTER //
// ./src/app/components/account/right-of-access/right-of-access.component.html